import { StyleSheet, Image,Dimensions } from "react-native";
import React from "react";
const overlayGIF = require("../../../../../assets/images/cards/isic-overlay.gif");
const OverlayGIF = () => {
  return <Image source={overlayGIF} style={styles.root} resizeMode="cover" />;
};

export default OverlayGIF;
const windowWidth = Dimensions.get("window").width;
const ratio = 1460 / 920;
const cardWidth = windowWidth * 0.95;
const cardHeight = cardWidth * ratio;
const styles = StyleSheet.create({
  root: {
    height: cardHeight,
    width: cardWidth,
    position: "absolute",
    marginTop: 45,
  },
});
